// URLs
export const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/ava-ai/oociehonanngbcampmpnoaoddafapbjg';
export const REDIRECT_URL = 'https://linkedin-auto-comment.vercel.app/';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/avacom-ai/';
export const PRIVACY_POLICY_URL = 'https://meirlejz.github.io/linkedin-comment-extension-privacy-policy.html';
export const WHATSAPP_NUMBER = '+972522796834';

export const PAYPRO_BASE_URL = 'https://store.payproglobal.com/checkout';


// Product IDs
export const PAYPRO_PRODUCT_ID = '113938';

// Routes
export const ROUTES = {
  HOME: '/',
  MANAGE_SUBSCRIPTION: '/manage-subscription'
};

// Environment Variables
export const ENV = {
  TEST_MODE: process.env.REACT_APP_TEST_MODE === 'true',
  PAYPRO_SECRET_KEY: process.env.REACT_APP_PAYPRO_SECRET_KEY
};
